import { useEffect, useRef, useState } from "react";
import { Loader2 } from "lucide-react";
import { http, errMsg } from "../../lib/api";

export const VenueTicks = ({ r, setR }) => {
  const [state, setState] = useState(r.venues ? "ok" : "loading");
  const [err, setErr] = useState("");
  const setRef = useRef(setR);
  setRef.current = setR;
  const has = !!r.venues;
  useEffect(() => {
    if (has) return;
    let live = true;
    http.post(`/imports/${r.iid}/venues`).then(({ data }) => { if (live) { setRef.current((s) => ({ ...s, venues: data.venues })); setState("ok"); } })
      .catch((e) => { if (live) { setErr(errMsg(e)); setState("error"); } });
    return () => { live = false; };
  }, [r.iid, has]);
  const off = new Set(r.unvisited || []);
  const toggle = (n) => setR((s) => { const u = new Set(s.unvisited || []); u.has(n) ? u.delete(n) : u.add(n); return { ...s, unvisited: [...u] }; });
  return (
    <div data-testid="venue-ticks" className="mt-5">
      <div className="eyebrow mb-1.5">✦ I've been here</div>
      {state === "loading" && <div data-testid="venue-ticks-loading" className="flex items-center gap-2 text-xs text-stone-500"><Loader2 size={13} className="animate-spin" /> Listing the venues in your file — about 20–60 seconds…</div>}
      {state === "error" && <div data-testid="venue-ticks-error" className="text-xs text-red-600">Couldn't list the venues ({err}). Every venue will be marked as visited — untick them in Been There afterwards.</div>}
      {state === "ok" && <>
        <p className="text-xs text-stone-500 mb-2">Untick any venue you haven't visited. {r.venues.length - off.size} of {r.venues.length} ticked.</p>
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-x-4 gap-y-1 max-h-72 overflow-auto rounded-md border border-stone-200 bg-white p-3">
          {r.venues.map((n, i) => (
            <label key={n} className="flex items-center gap-2 text-sm text-[#2B2A26]">
              <input data-testid={`venue-tick-${i}`} type="checkbox" checked={!off.has(n)} onChange={() => toggle(n)} /> {n}
            </label>
          ))}
        </div>
      </>}
    </div>
  );
};
